import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import knownHumanChromosomes from '../../constants/HumanChromosomeUtil';
import { setExcludedChromosomes } from '../../reducers/BuildRenderRequestSlice';

export const ChromosomeFilter = () => {
  const dispatch = useDispatch();
  const { excludedChromosomes } = useSelector((state: RootState) => state.buildRenderRequest);

  const onChromosomeChange = (chromosome: string, checked: boolean) => {
    let newExcluded = excludedChromosomes.filter(c => c !== chromosome);
    if (!checked) newExcluded = [...newExcluded, chromosome];
    dispatch(setExcludedChromosomes(newExcluded));
  };

  const toggleSelectAll = (checked: boolean) => {
    dispatch(setExcludedChromosomes(checked ? [] : knownHumanChromosomes));
  };

  return (
    <div className="chrom-list">
      {knownHumanChromosomes.map(c => (
        <label key={c} className="chrom-item">
          <input
            type="checkbox"
            checked={!excludedChromosomes.includes(c)}
            onChange={e => onChromosomeChange(c, e.target.checked)}
          />
          <span>Chromosome {c}</span>
        </label>
      ))}
      <label className="chrom-item select-all">
        <input
          type="checkbox"
          checked={excludedChromosomes.length === 0}
          onChange={e => toggleSelectAll(e.target.checked)}
        />
        <span>Select All</span>
      </label>
    </div>
  );
};
